import { render, staticRenderFns } from "./scanQR.vue?vue&type=template&id=dcc0dd1a&scoped=true"
import script from "./scanQR.vue?vue&type=script&lang=js"
export * from "./scanQR.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dcc0dd1a",
  null
  
)

export default component.exports